export function arrayEq(a, b) {
    if (a.length !== b.length) return false;
    a.forEach((i) => {
        if (a[i] !== b[i]) return false;
    });
    return true;
}
